import { render, staticRenderFns } from "./KasasaUpgradeCreateDialog.vue?vue&type=template&id=d13cc926"
import script from "./KasasaUpgradeCreateDialog.vue?vue&type=script&lang=ts"
export * from "./KasasaUpgradeCreateDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports